module.exports = __webpack_public_path__ + "static/saastory-illustration-3D-79ae6e892369427a5dd9fa449a551dee.png";